import { IonicModule, ModalController } from '@ionic/angular';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, first } from 'rxjs';
import { TranslocoModule } from '@ngneat/transloco';
import { CartComponent } from '../cart/cart.component';
import { TuiSvgModule } from '@taiga-ui/core';

@UntilDestroy()
@Component({
    selector: 'us-cart-dialog',
    template: `
        <ion-header>
            <ion-toolbar>
                <ion-title>{{ 'cart' | transloco }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button (click)="dismissModal()">
                        <tui-svg slot="icon-only" src="svg::close-outline"></tui-svg>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>

        <ion-content>
            <div class="main-content h-full">
                <us-cart></us-cart>
            </div>
        </ion-content>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [IonicModule, TranslocoModule, CartComponent, TuiSvgModule]
})
export class CartDialogComponent implements OnInit {
    constructor(private modalCtrl: ModalController, private router: Router) {}

    ngOnInit(): void {
        this.router.events
            .pipe(
                untilDestroyed(this),
                filter(e => e instanceof NavigationEnd),
                first()
            )
            .subscribe(async () => {
                await this.dismissModal();
            });
    }

    async dismissModal() {
        await this.modalCtrl.dismiss();
    }
}
